import { useCallback, useRef } from 'react';

// Returns a callback with a fixed identity that always invokes the latest
// `callback`. Use it for handlers passed to memoized children when the handler
// closes over state that changes often, so the children don't re-render just
// because the handler was recreated.
export const useStableCallback = <Args extends unknown[], Result>(
  callback: (...args: Args) => Result,
): ((...args: Args) => Result) => {
  const latest = useRef(callback);
  latest.current = callback;

  return useCallback((...args: Args) => latest.current(...args), []);
};
